import { render, staticRenderFns } from "./SimpleRequisiteRuleDisplay.vue?vue&type=template&id=2a1feafd&scoped=true&"
import script from "./SimpleRequisiteRuleDisplay.vue?vue&type=script&lang=js&"
export * from "./SimpleRequisiteRuleDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SimpleRequisiteRuleDisplay.vue?vue&type=style&index=0&id=2a1feafd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1feafd",
  null
  
)

export default component.exports